// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 776) return "static/chunks/776.db8d81117d9bb8b8.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 730 ? "44530001" : chunkId) + "-" + {"120":"936f27b752e7bf11","730":"b6c2e579550a1e0d"}[chunkId] + ".js";
};